import { AppRef } from 'common/modules/ReactShared';
import App from './App';

export default function setupAppInterface(): void {
  AppRef.setApp(new App());
}
